export default __webpack_public_path__ + "static/media/india_agriculture_market.3c88850dac41cd438f5e6e4570e211ab.png";